let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("70l3J")).then(() => parcelRequire('73fMo'));